import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const headerIconStyles = makeStyles((theme) => ({
    iconHeader: {
        display: 'flex',
        '&.center': {
            alignItems: 'center',
        },
        '& > svg': {
            
            height: '1rem',
            width: '1rem',
            flex: '0 0 auto',            
            '& + * ': {
                marginLeft: theme.spacing(.5),
            },
        },
        '& > * + svg': {
            marginLeft: theme.spacing(.5),
        },
        '& .clergy-icon': {
            fill: tcsmColors.blue,
            alignSelf: 'center',
            '&-lg': {
                height: '2rem',
                width: '2em',
            },
        },
        '& .warning-icon': {
            fill: tcsmColors.yellow,
        },
        '& .info-icon': {
            fill: tcsmColors.darkBlue,
        },
    },
    dioAdminHeader:{
        position: 'absolute',
        right: 0,
        marginRight: theme.spacing(1.5),
    },
}));



